import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center gap-3 py-3"
}
const _hoisted_5 = { class: "assets-grid-card" }
const _hoisted_6 = { class: "assets-grid-card__header" }
const _hoisted_7 = { class: "assets-grid-title" }
const _hoisted_8 = { class: "assets-grid-title__text" }
const _hoisted_9 = { class: "assets-grid-controls" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "assets-grid-card__body" }
const _hoisted_12 = { class: "average-cell" }
const _hoisted_13 = {
  key: 0,
  class: "param-chip"
}
const _hoisted_14 = {
  key: 1,
  class: "param-chip param-chip--empty"
}
const _hoisted_15 = {
  key: 2,
  class: "param-chip"
}
const _hoisted_16 = {
  key: 3,
  class: "param-chip param-chip--empty"
}
const _hoisted_17 = { class: "status-cell" }
const _hoisted_18 = { class: "status-line" }
const _hoisted_19 = { class: "param-chip status-chip status-chip--recent" }
const _hoisted_20 = { class: "status-hint" }
const _hoisted_21 = { class: "status-line" }
const _hoisted_22 = { class: "param-chip status-chip status-chip--active" }
const _hoisted_23 = { class: "status-hint" }
const _hoisted_24 = { class: "status-line" }
const _hoisted_25 = { class: "param-chip status-chip status-chip--inactive" }
const _hoisted_26 = { class: "status-hint" }
const _hoisted_27 = { class: "action-buttons" }
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = {
  key: 0,
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.listError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.listError), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("span", {
              class: "spinner-border text-primary",
              role: "status"
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetGroupsList.loading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-diagram-2" })
            ], -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('aside.menu.pages.assetsGroupsList')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assets.dataGrids.refresh'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshGrid && _ctx.refreshGrid(...args)))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assets.dataGrids.refresh')), 1)
            ], 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DxDataGrid, {
            ref: "gridRef",
            "data-source": _ctx.dataSource,
            "remote-operations": true,
            "hover-state-enabled": true,
            "column-auto-width": false,
            "show-borders": false,
            "show-column-lines": false,
            "show-row-lines": false,
            "column-hiding-enabled": true,
            "word-wrap-enabled": true
          }, {
            "average-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_12, [
                (data.data.temperatureAvg !== null && data.data.temperatureAvg !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-thermometer-half" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatAverage(data.data.temperatureAvg, '°C')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, " — ")),
                (data.data.humidityAvg !== null && data.data.humidityAvg !== undefined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-droplet-half" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatAverage(data.data.humidityAvg, '%')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, " — "))
              ])
            ]),
            "activity-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(data.data.activeRecentCount ?? 0) + " " + _toDisplayString(_ctx.$t('components.assetGroupsList.status.activeRecent')), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('components.assetGroupsList.status.activeRecentHint')), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(data.data.activeDailyCount ?? 0) + " " + _toDisplayString(_ctx.$t('components.assetGroupsList.status.activeDaily')), 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('components.assetGroupsList.status.activeDailyHint')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(data.data.inactiveCount ?? 0) + " " + _toDisplayString(_ctx.$t('components.assetGroupsList.status.inactive')), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('components.assetGroupsList.status.inactiveHint')), 1)
                ])
              ])
            ]),
            "actions-template": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary",
                  title: _ctx.$t('components.assetGroupsList.actions.details'),
                  onClick: ($event: any) => (_ctx.goToDetails(data.data))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "bi bi-eye" }, null, -1)
                ]))], 8, _hoisted_28)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: true }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxPaging, { "page-size": 20 }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [20],
                "show-info": true,
                "show-page-size-selector": false,
                "show-navigation-buttons": true
              }),
              _createVNode(_component_DxColumn, {
                "data-field": "name",
                caption: _ctx.$t('components.assetGroupsList.columns.name'),
                "min-width": 220
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.assetGroupsList.columns.activity'),
                "min-width": 200,
                "cell-template": "activity-template",
                "allow-filtering": false,
                "allow-sorting": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.assetGroupsList.columns.averageValue'),
                "min-width": 240,
                "cell-template": "average-template",
                "allow-filtering": false,
                "allow-sorting": false
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.assetGroupsList.columns.actions'),
                width: 140,
                "allow-filtering": false,
                "allow-sorting": false,
                "cell-template": "actions-template"
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source"]),
          (_ctx.isGridEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('components.assetGroupsList.empty')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}